import { AxiosInstance } from 'axios';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { JobEquipmentTypeLiterals } from '@trukt/types/Job';

export type EquipmentTypeSearchRequest = PaginatedQueryParams;
export type EquipmentTypeSearchResponse = PaginatedResults<{
  type: JobEquipmentTypeLiterals;
  isDefault: boolean;
}>;

export class EquipmentService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  searchTypes(request: EquipmentTypeSearchRequest) {
    return this.instance.get<EquipmentTypeSearchResponse>('/equipment/types', {
      params: request,
    });
  }
}
